import { render, staticRenderFns } from "./PerfilConsulta.vue?vue&type=template&id=e6007630&scoped=true&"
import script from "./PerfilConsulta.vue?vue&type=script&lang=js&"
export * from "./PerfilConsulta.vue?vue&type=script&lang=js&"
import style0 from "./PerfilConsulta.vue?vue&type=style&index=0&id=e6007630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6007630",
  null
  
)

export default component.exports